import { useNavigate, useParams } from "react-router-dom";
import "./EditPushNotification.css";
import { useEffect, useState } from "react";
import axios from "axios";

const EditPushNotification = () => {
  const navigate = useNavigate();
  const [userType, setUserType] = useState("");
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [link, setLink] = useState("");
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;
  const { id } = useParams();

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/notifications/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        const data = response.data?.data;
        setUserType(data.userType);
        setTitle(data.title);
        setMessage(data.message);
        setLink(data.link);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [API_BASE_URL, id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.put(
        `${API_BASE_URL}/admin/notifications/${id}`,
        { userType, title, message, link },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      alert("Notification updated successfully.");
      navigate("/all-push-notification");
    } catch (error) {
      console.error("Error updating notification:", error);
      alert("Failed to update notification. Please try again.");
    }
  };

  return (
    <>
      <div id="edit-all-notification-main-container">
        <div className="edit-all-notification-heading-main-div">
          <h4>Edit Notification</h4>
          <div className="notif-header-main-btns">
            <button onClick={() => navigate("/push-notification")}>
              Notification
            </button>
            <button onClick={() => navigate("/all-push-notification")}>
              All Notifications
            </button>
          </div>
        </div>
        <div className="edit-all-notification-inner-main ">
          <form onSubmit={handleSubmit}>
            <div className="edit-all-notification-input">
              <label>
                <b>Notification Send - Student/Teacher</b>
              </label>
              <select
                value={userType}
                onChange={(e) => setUserType(e.target.value)}
              >
                <option value="">--Select--</option>
                <option value="student">Student</option>
                <option value="teacher">Teacher</option>
              </select>
            </div>
            <div className="edit-all-notification-input">
              <label>
                <b>Title</b>
              </label>
              <input
                type="text"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                placeholder="Enter Title"
              />
            </div>
            <div className="edit-all-notification-input">
              <label>
                <b>Message</b>
              </label>
              <input
                type="text"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Enter Message"
              />
            </div>
            <div className="edit-all-notification-input">
              <label>
                <b>Link</b>
              </label>
              <input
                type="text"
                value={link}
                onChange={(e) => setLink(e.target.value)}
                placeholder="Enter Link"
              />
            </div>
            <div className="new-chapter-form-buttons">
              <button type="submit" className="new-chapter-submit-btn">
                Update
              </button>
              <button
                type="button"
                className="new-chapter-cancel-btn"
                onClick={() => navigate("/all-push-notification")}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default EditPushNotification;
